import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import useAuth from 'src/hooks/useAuth';
import Input from 'src/componentes/input';
import LucideIcon from 'src/componentes/lucide-icon';

const COOKIE_NAME = 'csat_delay';

const setCookie = (name, value, hours) => {
  const date = new Date();
  date.setTime(date.getTime() + hours * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
};

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
};

const satisfactionImagePaths = [
  {
    path: '/static/images/csat/angry.png',
    subTitleResourceId: 'muitoInsatisfeito',
    score: 1,
  },
  {
    path: '/static/images/csat/disappointed.png',
    subTitleResourceId: 'insatisfeito',
    score: 2,
  },
  {
    path: '/static/images/csat/neutral-emoticon.png',
    subTitleResourceId: 'indiferente',
    score: 3,
  },
  {
    path: '/static/images/csat/smiling-face-with-heart.png',
    subTitleResourceId: 'satisfeito',
    score: 4,
  },
  {
    path: '/static/images/csat/in-love.png',
    subTitleResourceId: 'muitoSatisfeito',
    score: 5,
  },
];

const CSAT = () => {
  const intl = useIntl();
  const { setPesquisaCSAT } = useAuth();

  const [isOpen, setIsOpen] = useState(true);
  const [display, setDisplay] = useState(false);
  const [form, setForm] = useState({});

  useEffect(() => {
    const hasDelayCookie = getCookie(COOKIE_NAME);

    if (!hasDelayCookie) {
      const timer = setTimeout(() => setDisplay(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (!isOpen) {
      const timer = setTimeout(() => setDisplay(false), 500);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const handleChangeForm = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const closeAndDelay = () => {
    setCookie(COOKIE_NAME, '1', 16);
    setIsOpen(false);
  };

  const handleSend = () => {
    setIsOpen(false);
    setPesquisaCSAT({ nota: form.nota, texto: form.texto });
  };

  const renderItem = (item) => {
    const isSelected = form.nota === item.score;

    return (
      <div
        key={item.score}
        className="d-flex flex-column justify-content-center align-items-center"
      >
        <div
          onClick={() => handleChangeForm('nota', item.score)}
          className="d-inline-flex justify-content-center align-items-center text-white rounded-lg cursor-pointer opacity-hover"
          style={{
            height: 40,
            width: 40,
            background: isSelected ? '#FFEAB3' : '#FFFFFF',
          }}
        >
          <img src={item.path} width="30" height="30" />
        </div>

        <span className="mt-1 text-sm text-muted">
          {intl.formatMessage({ id: item.subTitleResourceId })}
        </span>
      </div>
    );
  };

  const sendIsDisabled = form.nota === undefined;

  if (!display) return null;

  return (
    <div
      className="p-4 shadow-xl border position-fixed font-weight-bold bg-white text-center rounded-top-lg overflow-hidden"
      style={{
        zIndex: 100,
        bottom: 0,
        right: 20,
        maxWidth: 550,
        animation: `${
          isOpen ? 'openBottom' : 'closeBottom'
        } 0.5s ease-in-out forwards`,
      }}
    >
      <div className="d-flex justify-content-end mb-3">
        <LucideIcon
          className="cursor-pointer"
          onClick={closeAndDelay}
          icon="close"
        />
      </div>

      <div>{intl.formatMessage({ id: 'pesquisaCSATPergunta' })}</div>

      <div className="d-flex justify-content-around mt-3 mb-4">
        {satisfactionImagePaths.map(renderItem)}
      </div>

      <div>{intl.formatMessage({ id: 'pesquisaCSATMotivo' })}</div>

      <div className="d-flex align-items-center mt-3">
        <div style={{ flexGrow: 6 }}>
          <Input
            style={{ marginBottom: '-1rem' }}
            model={{
              label: '',
              value: form.texto,
              requestChange: (v) => handleChangeForm('texto', v),
            }}
          />
        </div>

        <a
          onClick={() => !sendIsDisabled && handleSend()}
          className={`ml-3 ${
            sendIsDisabled ? 'text-muted' : 'text-primary cursor-pointer'
          }`}
          style={{ flexGrow: 1, textDecoration: sendIsDisabled ? 'none' : '' }}
        >
          {intl.formatMessage({ id: 'label.enviar' })}
        </a>
      </div>
      <div className="mt-3">
        <a
          className="text-primary cursor-pointer text-sm"
          style={{ textDecoration: 'none', fontSize: '14px' }}
          onClick={closeAndDelay}
        >
          {intl.formatMessage({ id: 'responderMaisTarde' })}
        </a>
      </div>
    </div>
  );
};

export default CSAT;
